import { DDSTypography } from 'den-design-system'
import React from 'react'
import UsageBar from './UsageBar'
import { isNull } from 'lodash'
import pallete from '../../global/newPallete'

interface FileStorageCardProps {
  usage: number
  totalStorageInMB: number
  availableStorageInMB: number
  totalFiles?: number
}

const SFFileStorageCard: React.FC<FileStorageCardProps> = ({
  usage,
  totalStorageInMB,
  availableStorageInMB,
  totalFiles
}) => {
  const convertStorage = (size: number): string => {
    if (size >= 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} TB`
    else if (size >= 1024) return `${(size / 1024).toFixed(2)} GB`
    else return `${size} MB`
  }

  return (
    <div
      style={{
        borderColor: pallete.colors.stroke2,
        borderRadius: '8px'
      }}
      className='w-full max-w-[100%]  border p-[16px] space-y-[12px] shadow-sm bg-white flex flex-col'
    >
      <div className='flex flex-wrap justify-between gap-x-6 gap-y-4'>
        {/* Storage Usage */}
        <div className=' flex flex-col gap-[8px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark4}
          >
            Storage Usage
          </DDSTypography.Title>

          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.primary}
            className='text-[20px]'
          >
            {isNaN(usage) || !isFinite(usage) ? '-' : usage + '%'}
          </DDSTypography.Title>

          <UsageBar usage={usage} />
        </div>

        {/* Total Storage */}
        <div className=' flex flex-col gap-[4px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark4}
            className='text-[16px]'
          >
            Total Storage
          </DDSTypography.Title>

          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.textDark3}
            className='text-[18px] whitespace-nowrap'
          >
            {isNull(totalStorageInMB) ? '-' : convertStorage(totalStorageInMB)}
          </DDSTypography.Title>
        </div>

        {/* Available Storage */}
        <div className=' flex flex-col gap-[4px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark4}
            className='text-[16px]'
          >
            Available Storage
          </DDSTypography.Title>

          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.textDark3}
            className='text-[18px] whitespace-nowrap'
          >
            {isNull(availableStorageInMB) || availableStorageInMB < 0
              ? '-'
              : convertStorage(availableStorageInMB)}
          </DDSTypography.Title>
        </div>

        {/* Total Files */}
        <div className=' flex flex-col gap-[4px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark4}
          >
            Total Files
          </DDSTypography.Title>

          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.textDark3}
            className='whitespace-nowrap'
          >
            {typeof totalFiles === 'number'
              ? totalFiles?.toLocaleString('en-US')
              : '-'}
          </DDSTypography.Title>
        </div>
      </div>
    </div>
  )
}

export default SFFileStorageCard
